import { IQuestion } from "./interfaces/question";
import { IOption } from "./interfaces/option";
import * as _ from 'lodash';

export class Question implements IQuestion {
  constructor(name: string, description: string, helpText: string = '', options: IOption[] = [], index: number = 1, isRequired: boolean = false) {
    this.name = name;
    this.description = description;
    this.index = index;
    this.options = options;
    this.isRequired = isRequired;
    this.helpText = helpText;
  }

  questionId: number;
  name: string;
  description: string;
  index: number;
  isDeleted: boolean;
  options: IOption[];
  isRequired: boolean;
  helpText: string;
  questionTypeId: number;

  isValid(): boolean {
    let valid = (this.name === null || this.name === undefined) ? false : (this.description === null || this.description === undefined) ? false : (this.index > 0) ? true : false;

    //if (this.options.length > 0) {
    //  this.options.forEach(o => {
    //    if (!o.isValid()) {
    //      return false;
    //    }
    //  });
   // }

    return valid;
  }

  prepare(): void {
    if (this.index < 1) {
      this.index = 1;
    }

    if (!this.isDeleted) {
      this.isDeleted = false;
    }

    if (!this.isRequired) {
      this.isRequired = false;
    }

    if (this.options.length > 0) {
      for (let i = 0; i < this.options.length; i++) {
        this.options[i].index = i + 1;
      }

      this.options.forEach(o => {
        o.prepare();
      });
    }
  }
}
